import {
    GET_TESTIMONIALS,
    GET_NEWS,
    GET_NEXT_NEWS,
    GET_BANNERS,
    GET_NUTRITION_INSTITUTES,
    GET_BANNERS_FOR_MASTER_CATALOGS,
    GET_MASTER_CATALOGS,
    GET_CATALOGS,
    GET_CONTENTS,
    GET_CUISINES,
    GET_FAQS,
    GET_PRODUCTS,
    GET_NEXT_PRODUCTS,
    GET_PRODUCT_TYPES,
    GET_MEAL_TYPE,
    GET_RECIPES,
    GET_RECIPE_NUTRITIONS,
    GET_NEXT_RECIPES,
    GET_RECIPE_IMAGES,
    GET_PLATING_IMAGES,
    APPEND_PLATING_IMAGE,
    GET_PACKAGING_IMAGES,
    APPEND_PACKAGING_IMAGE,
    GET_SUBCATALOGS,
    SET_PRODUCT_TYPES,
    ADD_PRODUCT_QUANTITY,
    SET_PRODUCT,
    RESET_PRODUCTS,
    RESET_RECIPES,
    RESET_RECIPES_LOADER,
    SET_LANGUAGE,
    RECIPES_FAVORITES,
    REMOVE_FAV_RECIPES,
    GET_FAV_RECIPES
} from '../Types/types';


let intialState = {
    masterCatalogs: [],
    catalogs: [],
    activeProductTypes: [],
    activeProducts: [],
    activeLanguage: 'English',
    isLoadingRecipe: true,
    languages: [
        { label: 'English', value: 'english' },
        { label: 'Hindi', value: 'hindi' },
        { label: 'French', value: 'french' },
        { label: 'Italian', value: 'italian' },
        { label: 'Chinese', value: 'chinese' },
        { label: 'Spanish', value: 'spanish' },
        { label: 'Portgeous', value: 'Portgeous' }
    ],
    recipes: [],
    recipeComplete: false,
    isLoadingFavRecipes: true
}

export default function homeReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));

    switch (action.type) {
        case SET_LANGUAGE:
            return { ...state, activeLanguage: action.payload };
        case GET_TESTIMONIALS:
            return { ...state, testimonials: action.payload.rows };
        case GET_NEWS:
            return { ...state, newsList: action.payload.rows };
        case GET_NEXT_NEWS:
            return { ...state, newsList: state.newsList.concat(action.payload.rows) };
        case GET_BANNERS:
            return { ...state, allBanners: action.payload.rows, bannerCopy: action.payload.rows };
        case GET_BANNERS_FOR_MASTER_CATALOGS:
            return { ...state, banners: state.bannerCopy?.filter(el => el.masterCatalog?.id === Number(action.payload)) };
        case GET_NUTRITION_INSTITUTES:
            return { ...state, institutes: action.payload.rows };
        case GET_MASTER_CATALOGS:
            return { ...state, masterCatalogs: action.payload.rows };
        case GET_CATALOGS:
            if (action.payload.rows?.length) {
                stateCopy.catalogs = action.payload.rows
                stateCopy.activeProductTypes = [];
                stateCopy.activeProducts = [];
            } else {
                stateCopy.catalogs = [];
                stateCopy.subCatalogs = [];
                stateCopy.productTypes = [];
                stateCopy.activeProductTypes = [];
                stateCopy.products = [];
                stateCopy.activeProducts = [];
                stateCopy.cuisines = [];
            }
            return stateCopy;
        case GET_SUBCATALOGS:
            return { ...state, subCatalogs: action.payload.rows };
        case GET_CUISINES:
            return { ...state, cuisines: action.payload.rows };
        case GET_PRODUCT_TYPES:
            return {
                ...state,
                productTypes: action.payload.rows?.length ? action.payload.rows.map((item, i) => ({ ...item, isChecked: i === 0 })) : [],
                activeProductTypes: action.payload.rows?.length ? action.payload.rows.map((item, i) => ({ ...item, isChecked: i === 0 })) : [],
            };
        case RESET_PRODUCTS:
            // state.activeProducts = state.activeProducts.filter(el => el.productTypeId !== action.payload)
            const prodTypeid = state.activeProductTypes.map(el => el.id);
            const id = prodTypeid[prodTypeid?.length - 1]
            return {
                ...state, products: state.activeProducts.filter(el => el.productTypeId === id)
            }
        case GET_PRODUCTS:
            action.payload.data?.rows.forEach(item => {
                const foundIndex = state.activeProducts.find(i => i.id === item.id);
                if (foundIndex) {
                    item.isChecked = true;
                    item.productType = action.payload.prodType
                    item.productTypeId = action.payload.id
                    item.quantity = ''
                } else {
                    item.isChecked = false;
                    item.productType = action.payload.prodType
                    item.productTypeId = action.payload.id
                    item.quantity = ''
                }
            })
            return { ...state, products: action.payload.data.rows };
        case GET_NEXT_PRODUCTS:
            action.payload.data?.rows.forEach(item => {
                const foundIndex = state.activeProducts.find(i => i.id === item.id);
                if (foundIndex) {
                    item.isChecked = true;
                    item.productType = action.payload.prodType
                    item.productTypeId = action.payload.id
                    item.quantity = ''
                } else {
                    item.isChecked = false;
                    item.productType = action.payload.prodType
                    item.productTypeId = action.payload.id
                    item.quantity = ''
                }
            })
            return { ...state, products: stateCopy.products.concat(action.payload.data.rows) };
        case GET_MEAL_TYPE:
            return { ...state, mealTypes: action.payload.rows };
        case GET_RECIPES:
            if (action.payload.rows?.length) {
                return { ...state, recipes: action.payload.rows?.map(el => [{ ...el, images: [], packageWrapImages: [], recipe_image: '/images/placeholder-image.gif' }][0]), hash: action.payload.hash, isLoadingRecipe: false, recipeComplete: false };
            } else {
                return { ...state, recipeComplete: true, isLoadingRecipe: false };
            }
        case GET_NEXT_RECIPES:
            if (action.payload.rows?.length) {
                return { ...state, recipes: state.recipes.concat(action.payload.rows?.map(el => [{ ...el, images: [], packageWrapImages: [], recipe_image: '/images/placeholder-image.gif' }][0])), hash: action.payload.hash, isLoadingRecipe: false, recipeComplete: false };
            } else {
                return { ...state, recipeComplete: true, isLoadingRecipe: false };
            }
        case GET_RECIPE_IMAGES:
            stateCopy.recipes.forEach((el, i) => {
                if (i === action.payload.id) {
                    el.recipe_image = action.payload.data;
                }
            })
            return stateCopy;
        case GET_RECIPE_NUTRITIONS:
            if (action.payload.page === 'recipe') {
                state.recipes.forEach((el, i) => {
                    if (i === action.payload.id) {
                        el.ingredients = action.payload.data.ingredients;
                        el.nutrition_facts = action.payload.data.nutrition_facts;
                    }
                })
                return { ...state, recipes: state.recipes };
            } else {

                state.favRecipes.rows.forEach((el, i) => {
                    if (i === action.payload.id) {
                        el.recipe.data.ingredients = action.payload.data.ingredients;
                        el.recipe.data.nutrition_facts = action.payload.data.nutrition_facts;
                    }
                });
                return { ...state, favRecipes: state.favRecipes };
            }
        case GET_PLATING_IMAGES:
            if (action.payload.page === 'recipe') {
                state.recipes.forEach((el, i) => {
                    if (i === action.payload.id) {
                        el.images = action.payload.data;
                    }
                })
                return { ...state, recipes: state.recipes };
            } else {

                state.favRecipes.rows.forEach((el, i) => {
                    if (i === action.payload.id) {
                        el.images = action.payload.data;
                    }
                });
                return { ...state, favRecipes: state.favRecipes };
            }
        case APPEND_PLATING_IMAGE:
            if (action.payload.page === 'recipe') {
                state.recipes.forEach((el, i) => {
                    if (i === action.payload.id) {
                        el.images = action.payload.data
                        el.plating_creativity = [...el.plating_creativity, action.payload.val]
                    }
                })
                return { ...state, recipes: state.recipes };
            } else {

                state.favRecipes.rows.forEach((el, i) => {
                    if (i === action.payload.id) {
                        // if (!el.images) {
                        //     el.images = [];
                        // }
                        el.images = action.payload.data;
                    }
                });
                return { ...state, favRecipes: state.favRecipes };
            }
        case GET_PACKAGING_IMAGES:
            console.log(action.payload)
            if (action.payload.page === 'recipe') {
                state.recipes.forEach((el, i) => {
                    if (i === action.payload.id) {
                        el.packageWrapImages = action.payload.data;
                    }
                })
                return { ...state, recipes: state.recipes };
            } else {

                state.favRecipes.rows.forEach((el, i) => {
                    if (i === action.payload.id) {
                        // if (!el.images) {
                        //     el.images = [];
                        // }
                        el.packageWrapImages = action.payload.data;
                    }
                });
                return { ...state, favRecipes: state.favRecipes };
            }
        case APPEND_PACKAGING_IMAGE:
            console.log(action.payload)
            if (action.payload.page === 'recipe') {
                state.recipes.forEach((el, i) => {
                    if (i === action.payload.id) {
                        el.packageWrapImages = action.payload.data;
                        el.package_wrap_labeling = [...el.package_wrap_labeling, action.payload.val]
                    }
                })
                return { ...state, recipes: state.recipes };
            } else {

                state.favRecipes.rows.forEach((el, i) => {
                    if (i === action.payload.id) {
                        // if (!el.images) {
                        //     el.images = [];
                        // }
                        el.packageWrapImages = action.payload.data;

                    }
                });
                return { ...state, favRecipes: state.favRecipes };
            }
        case GET_FAV_RECIPES:
            return { ...state, favRecipes: action.payload, isLoadingFavRecipes: false };
        case RECIPES_FAVORITES:
            if (action.payload.obj.isFavorite) {
                stateCopy.recipes.forEach((el, i) => {
                    if (i === action.payload.idx) {
                        el.isFavorite = action.payload.obj.isFavorite;
                        el.recipeId = action.payload.id
                    }
                })
            } else {
                stateCopy.recipes.forEach((el, i) => {
                    if (el.recipeId === action.payload.obj.recipeId) {
                        el.isFavorite = action.payload.obj.isFavorite;
                    }
                })
            }
            return stateCopy;
        case REMOVE_FAV_RECIPES:
            return {
                ...state, favRecipes: { ...state.favRecipes, rows: state.favRecipes?.rows?.filter(el => el.id !== action.payload.id) }
            }
        case RESET_RECIPES:
            return {
                ...state, recipes: "", hash: "", isLoadingRecipe: true, recipeComplete: false
            }
        case RESET_RECIPES_LOADER:
            return {
                ...state, isLoadingRecipe: true
            }
        case GET_FAQS:
            return { ...state, faqs: action.payload.rows };
        case GET_CONTENTS:
            return { ...state, contents: action.payload };
        case SET_PRODUCT_TYPES:
            stateCopy.productTypes.forEach(el => {
                if (el.id === action.payload.id) {
                    el.isChecked = true
                }
            })
            if (!stateCopy.activeProductTypes.some(el => el.id === action.payload.id)) {
                const data = { ...action.payload, isChecked: !action.payload.isChecked }
                stateCopy.activeProductTypes = [...stateCopy.activeProductTypes, data];
            } else {
                stateCopy.activeProductTypes.forEach(el => {
                    if (el.id === action.payload.id) {
                        el.isChecked = true
                    }
                })
            }
            return stateCopy;
        case SET_PRODUCT:
            stateCopy.products.forEach(el => {
                if (el.id === action.payload.id) {
                    el.isChecked = !el.isChecked
                }
            })
            if (!stateCopy.activeProducts.some(el => el.id === action.payload.id)) {
                const data = { ...action.payload, isChecked: !action.payload.isChecked }
                stateCopy.activeProducts = [...stateCopy.activeProducts, data];
            } else {
                stateCopy.activeProducts.forEach(el => {
                    if (el.id === action.payload.id) {
                        el.isChecked = !el.isChecked
                    }
                })
            }

            return stateCopy;

        case ADD_PRODUCT_QUANTITY:
            stateCopy.products.forEach(el => {
                if (el.id === action.payload.id) {
                    el.isChecked = true
                    el.quantity = action.payload.val
                }
            })
            stateCopy.activeProducts.forEach(el => {
                if (el.id === action.payload.id) {
                    el.isChecked = true
                    el.quantity = action.payload.val
                }
            })
            return stateCopy;
        default:
            return state;
    }
}
